export default "__VITE_ASSET__BYtIHeFU__"